import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { TableColumns } from '@aid/shared/types/interfaces/table-columns.interface';

@Component({
  selector: 'aid-http-table',
  template: `
    <div class="container full-height aid-layout-column aid-flex-fill">
      @if (loading) {
        <div class="loading-shade">
          <mat-spinner></mat-spinner>
        </div>
      }

      <div
        [ngStyle]="{
          'max-height': tableHeight ? tableHeight + 'px' : '100%'
        }"
        style="overflow: auto; position: relative"
        class="aid-layout-row"
      >
        <table
          mat-table
          [dataSource]="data ?? noRows"
          matSort
          class="full-width aid-table-density"
        >
          @for (column of tableColumns | keyvalue; track column) {
            <ng-container matColumnDef="{{ column.key }}">
              @if (!!column.value.actions) {
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="action-column">
                  @for (action of column.value.actions; track action) {
                    <button mat-icon-button (click)="action.onPress(element)">
                      <mat-icon svgIcon="{{ action.icon }}"></mat-icon>
                    </button>
                  }
                </td>
              }
              @if (!column.value.actions) {
                <th mat-header-cell *matHeaderCellDef>
                  {{ column.value.title | translate | uppercase }}
                </th>
                <td mat-cell *matCellDef="let element">
                  @if (!column.value.isArray) {
                    <div>
                      @if (column.value.displayFn) {
                        <div>
                          {{ column.value.displayFn(element) }}
                        </div>
                      } @else {
                        {{ element[column.key] ? element[column.key] : '-' }}
                      }
                    </div>
                  } @else {
                    @for (item of element[column.key]; track item) {
                      <div>
                        @if (column.value.displayFn) {
                          <div>
                            {{ item ? column.value.displayFn(item) : '-' }}
                          </div>
                        } @else {
                          {{ item ? item : '-' }}
                        }
                      </div>
                    }
                    @if (element[column.key].length === 0) {
                      <div>-</div>
                    }
                  }
                </td>
              }
            </ng-container>
          }

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr
            [ngClass]="{ selectable: selectable }"
            (click)="onSelect(row)"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
        </table>
      </div>

      <aid-empty-table
        [loading]="loading"
        [data]="data"
        [message]="empty"
      ></aid-empty-table>
      @if (!data) {
        <div class="padding-16 aid-layout-row aid-layout-align-center-center">
          <mat-spinner diameter="48"></mat-spinner>
        </div>
      }
      @if (count) {
        <mat-paginator
          [pageSizeOptions]="[10, 20, 30]"
          [length]="count"
          (page)="onPage($event)"
        ></mat-paginator>
      }
    </div>
  `,
  styleUrls: ['./http-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HttpTableComponent implements OnInit {
  @Input() data?: any[];
  @Input() loading?: boolean;
  @Input({ required: true }) tableColumns: TableColumns = {};
  @Input() tableHeight?: number;
  @Input() canEdit = false;
  @Input() canRemove = false;
  @Input() selectable = false;
  @Input() count?: number;
  @Input() empty?: string;

  @Output() edit = new EventEmitter();
  @Output() remove = new EventEmitter();
  @Output() select = new EventEmitter();
  @Output() page = new EventEmitter<PageEvent>();

  displayedColumns: string[] = [];
  readonly noRows: never[] = [];
  timer = 0;

  constructor() {}

  ngOnInit() {
    this.displayedColumns = Object.keys(this.tableColumns);
  }

  onSelect(row: unknown) {
    if (this.selectable) {
      this.select.emit(row);
    }
  }

  onPage(page: PageEvent) {
    page.pageIndex++;
    this.page.emit(page);
  }
}
